import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import SelectInput from '#client/components/SelectInput';
import { checkDepositStatusOptions } from '#client/constants/transaction';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useMobileCheckDeposit from '#client/hooks/useMobileCheckDeposit';
import { getMonthSelectOptions } from '#client/utils/date';
import { getOptionName } from '#client/utils/transaction';

import { FilterButtonStyled, OptionButtonStyle } from './FilterCheckHistory.styles';

import { MONTH_CHECK_HISTORY, STATUS } from '../constants/filter';

const monthOptions = getMonthSelectOptions();

export default function FilterCheckHistory({
  filters,
  isDisableButtons,
  handleDesktopFilterChange,
  statementButton,
  setShowMonthCheckHistoryOptions,
  setShowStatusOptions,
  enableCheckDepositBtn,
  handleOpenCheckDepositModal
}) {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  const { isEnableMobileCheckDeposit, launchCheckDeposit } = useMobileCheckDeposit();

  const onClickCheckDeposit = () => {
    if (isEnableMobileCheckDeposit) {
      launchCheckDeposit();
    } else {
      handleOpenCheckDepositModal();
    }
  };

  return isDesktop ? (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing="8px"
      >
        <Box>
          <SelectInput
            bordered
            disabled={isDisableButtons}
            handleChange={handleDesktopFilterChange(MONTH_CHECK_HISTORY)}
            Id="monthCheckHistory"
            label="Month"
            minWidth={100}
            options={monthOptions}
            value={filters[MONTH_CHECK_HISTORY]}
          />
        </Box>
        <Box>
          <SelectInput
            bordered
            disabled={isDisableButtons}
            handleChange={handleDesktopFilterChange(STATUS)}
            Id="status"
            label="Status"
            minWidth={100}
            options={checkDepositStatusOptions}
            value={filters[STATUS]}
          />
        </Box>
      </Stack>
      {statementButton}
    </Stack>
  ) : (
    <Stack
      direction="column-reverse"
      spacing="8px"
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing="8px"
        width="100%"
      >
        <FilterButtonStyled
          disabled={isDisableButtons}
          endIcon={
            <SharedAsset
              alt=""
              src="/s2/icon/arrow-sm-down-outline.svg"
            />
          }
          onClick={() => {
            setShowMonthCheckHistoryOptions(true);
          }}
          sx={OptionButtonStyle}
          variant="outlined"
        >
          {getOptionName(filters[MONTH_CHECK_HISTORY], monthOptions) ?? 'Month'}
        </FilterButtonStyled>
        <FilterButtonStyled
          disabled={isDisableButtons}
          endIcon={
            <SharedAsset
              alt=""
              src="/s2/icon/arrow-sm-down-outline.svg"
            />
          }
          onClick={() => {
            setShowStatusOptions(true);
          }}
          sx={OptionButtonStyle}
          variant="outlined"
        >
          {getOptionName(filters[STATUS], checkDepositStatusOptions) ?? 'Status'}
        </FilterButtonStyled>
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing="8px"
        width="100%"
      >
        {enableCheckDepositBtn && (
          <Stack flex={1}>
            <Button
              icon={
                <SharedAsset
                  alt=""
                  src="/s2/icon/camera-outline.svg"
                  width={16}
                />
              }
              onClick={onClickCheckDeposit}
              size="small"
              sx={OptionButtonStyle}
              variant="outlined"
            >
              Check Deposit
            </Button>
          </Stack>
        )}
        <Stack flex={1}>{statementButton}</Stack>
      </Stack>
    </Stack>
  );
}

FilterCheckHistory.propTypes = {
  filters: PropTypes.shape({}),
  isDisableButtons: PropTypes.bool,
  handleDesktopFilterChange: PropTypes.func,
  statementButton: PropTypes.node,
  setShowMonthCheckHistoryOptions: PropTypes.func,
  setShowStatusOptions: PropTypes.func,
  handleOpenCheckDepositModal: PropTypes.func,
  enableCheckDepositBtn: PropTypes.bool
};
